<script setup>
import AdverseEvent from "@/views/projects/dashboard/adverseEvent.vue"
import EnrollmentStatus from "@/views/projects/dashboard/enrollmentStatus.vue"
import StudyInformation from "@/views/projects/dashboard/studyInformation.vue"
import StudyNotification from "@/views/projects/dashboard/studyNotification.vue"
import UnansweredEcrf from "@/views/projects/dashboard/unansweredEcrf.vue"

definePage({
  meta: {
    action: 'read',
    subject: 'project',
  },
})
</script>

<template>
  <h3 class="text-lg font-semibold mb-8">
    대시보드
  </h3>
  <VRow>
    <VCol
      cols="12"
      lg="6"
    >
      <StudyInformation />
    </VCol>
    <VCol
    
      cols="12"
      lg="6"
    >
      <StudyNotification />
    </VCol>
    <VCol

      v-if="$can('read', 'dashboard') "
      cols="12"
      lg="6"
    >
      <AdverseEvent />
    </VCol>
    <VCol 
      v-if="$can('read', 'dashboard') "
      cols="12"
      lg="6"
    >
      <UnansweredEcrf />
    </VCol>
    <!-- [등록된 동물 현황] 숨김 처리
    <VCol
      cols="12"
      lg="12"
    >
      <EnrollmentStatus />
    </VCol>
    -->
  </VRow>
</template>
